"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var constants_1 = require("./constants");
var moduleState = function (rootState) { return rootState[constants_1.namespace]; };
exports.attributes = reselect_1.createSelector(moduleState, function (state) { var _a; return (_a = state.userAttributes) === null || _a === void 0 ? void 0 : _a.data; });
exports.attriburtesError = reselect_1.createSelector(moduleState, function (state) { var _a; return (_a = state.userAttributes) === null || _a === void 0 ? void 0 : _a.error; });
//# sourceMappingURL=selectors.js.map